import React from "react";
import { Save, Undo2, Loader2 } from "lucide-react";

// Sticky footer shown while a saved snapshot has unsaved edits.
export const SaveChangesBar = ({ t, onSave, onDiscard, saving, testid = "save-changes" }) => (
  <div className="sticky bottom-0 mt-4 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-xmas-gold/40 bg-xmas-navycard/95 px-4 py-3 shadow-[0_-8px_24px_rgba(0,0,0,0.35)] backdrop-blur" data-testid={`${testid}-bar`}>
    <span className="text-xs text-xmas-champagne">{t("saves.unsaved")}</span>
    <div className="flex items-center gap-2">
      <button type="button" onClick={onDiscard} data-testid={`${testid}-discard`} className="inline-flex items-center gap-1.5 rounded-full border border-xmas-gold/30 px-4 py-2 text-xs text-xmas-snow transition hover:border-xmas-gold">
        <Undo2 className="h-3.5 w-3.5" /> {t("saves.discard")}
      </button>
      <button type="button" onClick={onSave} disabled={saving} data-testid={`${testid}-save`} className="btn-gold inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-xs font-bold uppercase tracking-wider disabled:opacity-50">
        {saving ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Save className="h-3.5 w-3.5" />} {t("saves.save_changes")}
      </button>
    </div>
  </div>
);
